import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { bootstrap } from "@containers/Auth/store/actions";
import { bootstrapped } from "@containers/Auth/store/selectors";

/**
 * Restores the session on a cold start. The access token is kept in memory only, so it is gone
 * after a reload and has to be re-issued from the refresh token cookie before any route renders.
 *
 * @return {boolean} false until the session is known, one way or the other
 */
function useAuthBootstrap(): boolean {
  const dispatch = useDispatch();
  const isBootstrapped = useSelector(bootstrapped());

  useEffect(() => {
    dispatch(bootstrap.request());
  }, [dispatch]);

  return isBootstrapped;
}

export default useAuthBootstrap;
